import React from 'react';
import './Typography.scss';

export default class Typography extends React.Component {

      render() {
            return (
                  <div>
                  <h1> Heading h1 </h1><p>font-size: 2.5rem;</p>
                  <h2> Heading h2 </h2><p>font-size: 2rem;</p>
                  <h3> Heading h3 </h3><p>font-size: 1.75rem;</p>
                  <h4> Heading h4 </h4><p>font-size: 1.5rem;</p>
                  <h5> Heading h5 </h5><p>font-size: 1.25rem;</p>
                  <h6> Heading h6 </h6><p>font-size: 1rem;</p>
                


                        </div>
            );
      }
};


// WEBPACK FOOTER //
// ./src/components/docs/styles/Typography/Typography.js